import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { rgba } from 'polished';

export const ClicLogo = ({ link, ...props }) => {
  const currentTheme = useContext(ThemeContext);
  return (
    <ClicHeaderLogo {...props}>
      <Link to={{ pathname: link }}>
        <Logo
          src={
            currentTheme.name === 'light'
              ? require('../../../../img/logo-light.svg').default
              : require('../../../../img/logo-dark.svg').default
          }
          alt="S4C Clic"
        />
      </Link>
    </ClicHeaderLogo>
  );
};

const ClicHeaderLogo = styled.div`
  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 0;
    background: none;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      box-shadow: none !important;
    }
    &:active {
      box-shadow: ${(props) =>
        props.theme.name === 'light'
          ? `0px 0px 0px 2px ${rgba(props.theme.color.primaryFull, 0.2)}`
          : `0px 0px 0px 2px ${props.theme.color.primary10}`} !important;
    }
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
    @media screen and (min-width: 768px) {
      padding-left: 11px;
    }
  }
`;

const Logo = styled.img`
  height: 28px;
  width: 129px;
`;
